<template>
    <section>
        <h4>Set up your device</h4>
        <p>For example ZTE or TP-Link</p>
        <p class="sub-text">The Access Point Name (APN) on your LTE modem will have to be changed before you can use the <span v-html="provider"></span> services. Please follow the steps below to get connected.</p>
        <div class="divider"></div>
        <div class="config-steps">
            <config-step v-for="step in steps" :step="step"></config-step>
        </div><!-- end.config-steps -->
        <p class="foot-note">Your services should be active within 30 minutes, but may take up to 48 hours.</p>
        <section-footer
            :buttons="buttons"
            @next="startOver()">
        </section-footer>
    </section>
</template>

<script>
    import ConfigStep from '@/components/ConfigStep'
    import SectionFooter from '@/components/SectionFooter'

    export default {
        components: {
            ConfigStep,
            SectionFooter,
        },
        computed: {
            provider() {
                return '';
            },
            buttons() {
                return [
                    {
                        label: 'Start Again',
                        event: 'next',
                        class: '',
                        disabled: false
                    }
                ]
            }
        },
        methods: {
            startOver() {
                this.$store.commit('reset');
                this.$router.push({name: 'home'});
            }
        },
        data() {
            return {
                steps: [
                    {
                        title: 'Installing the SIM card',
                        steps: [
                            {
                                content: 'Carefully push out the correct size SIM for your device.',
                                subSteps: false
                            },
                            {
                                content: 'Insert the SIM card into the modem. Make sure the SIM faces the right direction.',
                                subSteps: false
                            },
                        ]
                    },
                    {
                        title: 'Power up the modem',
                        steps: [
                            {
                                content: 'Plug the modem into a wall socket and switch it on.',
                                subSteps: false
                            },
                        ]
                    },
                    {
                        title: 'Connect your modem to your computer',
                        steps: [
                            {
                                content: 'Connect your modem to your computer to the LAN port via Ethernet cable.',
                                subSteps: false
                            }
                        ]
                    },
                    {
                        title: 'Open your modem’s web management page',
                        steps: [
                            {
                                content: 'Open your preferred web browser (Chrome, Firefox, Safari, Edge, etc.) on your computer.',
                                subSteps: false
                            },
                            {
                                content: 'Log into your modem.',
                                subSteps: false
                            },
                        ]
                    },
                    {
                        title: 'Change your APN settings',
                        steps: [
                            {
                                content: 'Once logged in, find the APN section. Depending on the device you are using, the APN section can usually be found under Network Settings, Dial-up Settings or Mobile categories.',
                                subSteps: false
                            },
                            {
                                content: 'You will have to create a new APN profile.',
                                subSteps: false
                            },
                            {
                                content: 'In the New Profile section, enter the following details:',
                                subSteps: [
                                    'Profile name: afrihost',
                                    'Username and Password: (leave these blank)',
                                    'IP Type: IPv4',
                                    'APN: <strong>ws.afrihost.fwa</strong> (all lower case, no spaces)',
                                ]
                            },
                            {
                                content: "Save your new APN profile.",
                                subSteps: false
                            },
                            {
                                content: "Make sure your select 'afrihost' in the Profile name dropdown.",
                                subSteps: false
                            },
                            {
                                content: "Save your settings.",
                                subSteps: false
                            },
                        ]
                    },
                ]
            }
        }
    }
</script>